var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComprar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero",
    stroke: "#6E6259"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.4,
    d: "M18.813 0H2.187C.981 0 0 1.052 0 2.344v10.312C0 13.948.98 15 2.187 15h16.626C20.019 15 21 13.948 21 12.656V2.344C21 1.052 20.02 0 18.813 0zM20 12.607c0 .768-.581 1.393-1.295 1.393H2.295C1.581 14 1 13.375 1 12.607V2.393C1 1.625 1.581 1 2.295 1h16.41C19.419 1 20 1.625 20 2.393v10.214h0z",
    transform: "translate(-20 -609) translate(20 609) translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.4,
    d: "M6.563 8.75h-3.5c-.242 0-.438.196-.438.438 0 .241.196.437.438.437h3.5c.241 0 .437-.196.437-.437 0-.242-.196-.438-.437-.438zM10.938 10.5H3.063c-.242 0-.438.196-.438.438 0 .241.196.437.438.437h7.875c.241 0 .437-.196.437-.437 0-.242-.196-.438-.437-.438z",
    transform: "translate(-20 -609) translate(20 609) translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.2,
    d: "M15.75 9.625c0-.247.104-.477.293-.646.091-.083.145-.201.145-.325s-.054-.243-.145-.326c-.324-.292-.74-.453-1.168-.453-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75c.429 0 .844-.16 1.168-.452.091-.083.145-.202.145-.326s-.054-.242-.145-.325c-.189-.17-.293-.4-.293-.647zm-.654.845c-.532.146-1.096-.288-1.096-.845 0-.482.392-.875.875-.875.075 0 .15.01.221.03-.143.257-.221.548-.221.845 0 .298.078.588.221.845z",
    transform: "translate(-20 -609) translate(20 609) translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.4,
    d: "M4.812 6.125h-1.75c-.241 0-.437.196-.437.438 0 .241.196.437.438.437h1.75c.241 0 .437-.196.437-.437 0-.242-.196-.438-.438-.438zM8.313 6.125h-1.75c-.242 0-.438.196-.438.438 0 .241.196.437.438.437h1.75c.241 0 .437-.196.437-.437 0-.242-.196-.438-.437-.438zM11.813 6.125h-1.75c-.242 0-.438.196-.438.438 0 .241.196.437.438.437h1.75c.241 0 .437-.196.437-.437 0-.242-.196-.438-.437-.438z",
    transform: "translate(-20 -609) translate(20 609) translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.2,
    d: "M16.625 7.875c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75-.785-1.75-1.75-1.75zm0 2.625c-.483 0-.875-.393-.875-.875s.392-.875.875-.875.875.393.875.875-.392.875-.875.875z",
    transform: "translate(-20 -609) translate(20 609) translate(0 3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprar);
export default __webpack_public_path__ + "static/media/comprar.a19c93cf.svg";
export { ForwardRef as ReactComponent };